import {
    Component
  } from '@angular/core';
  import {
    AccountService
  } from '../../../../_services';
  @Component({
    selector: 'maui-footer',
    templateUrl: 'maui-footer.component.html'
  })
  export class MauiFooterComponent {
    constructor(private accountService: AccountService) {}
  }